module.exports = __webpack_public_path__ + "img/giant-tower.eb776746.jpg";